module.exports = __webpack_public_path__ + "static/lab2-40afa6bf6d43cfdcd96706dee22e8770.png";